export const EMOJI_SHORTLIST = [
    {emoji:'🙂', cssClass:'smile'},
    {emoji:'🤔', cssClass:'thinking'},
    {emoji:'😂', cssClass:'laugh'},
    {emoji:'😎', cssClass:'cool'},
    {emoji:'😮', cssClass:'surprise'},
    {emoji:'🙁', cssClass:'sad'},
    {emoji:'👍', cssClass:'thumbsUp'},
    {emoji:'👎', cssClass:'thumbsDown'},
  ]